export default __webpack_public_path__ + "static/fileImage-b19d29127ed1666191243e634b7fccf5.jpg";